<template>
  <div class="layout-bind-users">
    <DataGridBubble transition="dialog-fade"
                    popper-class="layout-bind-users-popover"
                    :visible.sync="visible"
                    :visible-arrow="false"
                    @open.once="loadBindUsers"
                    @closed="handleClosed">
      <template #reference>
        <el-tooltip content="账户切换"
                    placement="bottom"
                    :disabled="visible"
                    :enterable="false">
          <slot :show="show"></slot>
        </el-tooltip>
      </template>
      <div class="users-wrap">
        <div class="bind-head">
          <div class="title">账户切换</div>
          <div v-if="showSetting"
               class="extra">
            <template v-if="editMode">
              <el-button size="mini"
                         type="text"
                         icon="el-icon-circle-check"
                         @click="toggleEditMode"></el-button>
            </template>
            <template v-else>
              <el-button size="mini"
                         type="text"
                         icon="el-icon-setting"
                         @click="toggleEditMode"></el-button>
            </template>
          </div>
        </div>
        <AppScrollbar style="height: 100%">
          <div class="user-list">
            <template v-if="users">
              <div v-for="(user, index) in users"
                   :key="'user-' + index"
                   class="user">
                <div class="label"
                     :title="`${user.loginId}/${user.trueName}`">
                  <div v-if="user.roleName"
                       class="title">
                    <el-tag size="mini">{{user.roleName}}</el-tag>
                  </div>
                  <div class="detail">
                    <span class="login-id console-font">{{user.loginId}}</span>
                    <span class="true-name">{{user.trueName}}</span>
                  </div>
                </div>
                <div class="extra">
                  <template v-if="user.current">
                  <span class="current">
                    <i class="el-icon-user"></i>
                    <span>登录中</span>
                  </span>
                  </template>
                  <template v-else>
                    <template v-if="editMode">
                      <el-popconfirm title="确定要移除选择的账户吗？"
                                     popper-class="layout-bind-user-remove-popover"
                                     @onConfirm="handleRemove(user)"
                                     @confirm="handleRemove(user)">
                        <template #reference>
                          <el-button size="mini"
                                     type="text"
                                     icon="el-icon-delete"
                                     class="is-danger"
                                     :disabled="user.loading">移除</el-button>
                        </template>
                      </el-popconfirm>
                    </template>
                    <template v-else>
                      <WxBindLogin :user="user"
                                   @redirect="handleRedirect">
                        <template #default="{login, logging}">
                          <el-button size="mini"
                                     type="text"
                                     icon="el-icon-video-play"
                                     :disabled="logging"
                                     @click="login">登录</el-button>
                        </template>
                      </WxBindLogin>
                    </template>
                  </template>
                </div>
              </div>
            </template>
            <template v-else>
              <template v-if="loading">
                <div class="loading">
                  <i class="el-icon-loading"></i>
                </div>
              </template>
              <template v-else>
                <div class="load-err">
                  <el-button size="mini"
                             type="text"
                             icon="el-icon-refresh"
                             @click="loadBindUsers">重新加载</el-button>
                </div>
              </template>
            </template>
          </div>
        </AppScrollbar>
        <div class="bind-wrap">
          <el-button size="mini"
                     type="primary"
                     icon="el-icon-circle-plus-outline"
                     @click="showUserAdd">添加账号</el-button>
        </div>
      </div>
    </DataGridBubble>
    <DataGridDialog title="添加账号"
                    width="420px"
                    custom-class="layout-bind-user-add-popover"
                    :visible.sync="userAdd.visible"
                    @open="beforeShowUserAdd"
                    @close="afterHideUserAdd">
      <div class="user-add-wrap">
        <el-form size="small">
          <el-form-item>
            <el-input v-model.trim="userAdd.form.loginId"
                      type="text"
                      placeholder="请输入用户名（账号或身份证号）"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="userAdd.form.password"
                      type="password"
                      placeholder="请输入密码"></el-input>
          </el-form-item>
          <el-form-item>
            <el-input v-model="userAdd.form.authCode"
                      type="text"
                      placeholder="请输入验证码">
              <template #suffix>
                <img :src="`/index/plat/authImg/bindUsers?t=${userAdd.timeStamp}`"
                     alt="验证码"
                     title="点击更换验证码"
                     @click="reloadUserAddImage"/>
              </template>
            </el-input>
          </el-form-item>
        </el-form>
      </div>
      <div class="user-add-footer">
        <el-popover v-model="userAdd.showCheck"
                    trigger="manual"
                    placement="bottom"
                    popper-class="layout-bind-user-add-check-popper"
                    :title="userAdd.check ? userAdd.check.label : ''"
                    :disabled="!userAdd.check">
          <div v-if="userAdd.check && userAdd.check.items"
               class="check-wrap">
            <ul class="items">
              <li v-for="item in userAdd.check.items" :key="item.value">
                <el-button size="small"
                           type="primary"
                           :disabled="userAdd.loadCheck"
                           @click="handleCheckUserAdd(item)">{{item.label}}</el-button>
              </li>
            </ul>
            <div class="append">
              <el-button size="small"
                         type="primary"
                         plain
                         :loading="userAdd.loadCheck"
                         @click="handleCheckQuit">{{userAdd.loadCheck ? '绑定中...' : '取消绑定'}}</el-button>
            </div>
          </div>
          <el-button slot="reference"
                     type="primary"
                     :loading="userAdd.committing"
                     :disabled="userAdd.showCheck"
                     @click="handleUserAdd">
            <span>{{userAdd.committing ? '绑定中...' : '绑定账户'}}</span>
          </el-button>
        </el-popover>
      </div>
    </DataGridDialog>
  </div>
</template>

<script>
import DataGridBubble from './elements/grid/DataGridBubble'
import DataGridDialog from './elements/grid/DataGridDialog'
import AppScrollbar from './elements/AppScrollbar'
import WxBindLogin from './user/WxBindLogin'
export default {
  name: 'LayoutBindUsers',
  components: {
    DataGridBubble,
    DataGridDialog,
    AppScrollbar,
    WxBindLogin
  },
  data () {
    return {
      visible: false,
      loading: false,
      users: null,
      editMode: false,
      userAdd: {
        visible: false,
        timeStamp: Date.now(),
        form: {
          loginId: '',
          password: '',
          authCode: ''
        },
        committing: false,
        check: null,
        showCheck: false,
        loadCheck: false
      }
    }
  },
  computed: {
    showSetting () {
      let users = this.users
      if (users) {
        return users.some(user => !user.current)
      }
    }
  },
  methods: {
    show () {
      this.visible = true
    },
    hide () {
      this.visible = false
    },
    toggleVisible () {
      this.visible = !this.visible
    },
    toggleEditMode () {
      this.editMode = !this.editMode
    },
    loadBindUsers () {
      this.loading = true
      this.$ajax({
        url: '/index/ws/wx/bind/users',
        method: 'post',
        disableErrorPage: true
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.users = response.data.users || []
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败')
      }).finally(() => {
        this.loading = false
      })
    },
    handleClosed () {
      this.editMode = false
    },
    handleRemove (user) {
      this.$set(user, 'loading', true)
      this.$ajax({
        url: '/index/ws/wx/bind/remove',
        method: 'post',
        disableErrorPage: true,
        data: this.$qs.stringify({
          loginId: user.loginId
        })
      }).then((response) => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.$message.success(response.data['message'])
              this.$nextTick(() => {
                let users = this.users
                if (users) {
                  let index = users.indexOf(user)
                  if (index >= 0) {
                    users.splice(index, 1)
                  }
                }
              })
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('请求发送失败，请稍后重试')
      }).finally(() => {
        this.$set(user, 'loading', false)
      })
    },
    showUserAdd () {
      this.hide()
      this.$nextTick(() => {
        this.userAdd.visible = true
      })
    },
    hideUserAdd () {
      this.userAdd.visible = false
    },
    beforeShowUserAdd () {
      Object.keys(this.userAdd.form).forEach(key => {
        this.userAdd.form[key] = ''
      })
    },
    afterHideUserAdd () {
      this.handleCheckQuit()
    },
    reloadUserAddImage () {
      this.userAdd.timeStamp = Date.now()
    },
    handleUserAdd () {
      if (!this.userAdd.form.loginId) {
        this.$message.warning('请输入用户名')
        return
      }
      if (!this.userAdd.form.password) {
        this.$message.warning('请输入登录密码')
        return
      }
      if (!this.userAdd.form.authCode) {
        this.$message.warning('请输入登录验证码')
        return
      }
      this.userAdd.committing = true
      this.$ajax({
        url: '/index/ws/wx/bind/add',
        method: 'post',
        data: this.$qs.stringify({
          loginId: this.userAdd.form.loginId,
          password: this.$md5(this.userAdd.form.password),
          authCode: this.userAdd.form.authCode
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              let check = response.data.check
              if (check) {
                this.userAdd.check = check
                this.userAdd.showCheck = true
              } else {
                this.$message.success(response.data['message'])
                this.hideUserAdd()
                this.$nextTick(() => {
                  this.loadBindUsers()
                })
              }
              this.$nextTick(() => {
                this.userAdd.form.password = ''
                this.userAdd.form.authCode = ''
                this.reloadUserAddImage()
              })
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              this.$nextTick(() => {
                this.userAdd.form.password = ''
                this.userAdd.form.authCode = ''
                this.reloadUserAddImage()
              })
              break
            }
          }
        }
      }, () => {
        this.$message.error('登录请求发送失败')
      }).finally(() => {
        this.userAdd.committing = false
      })
    },
    handleCheckUserAdd (checkItem) {
      let check = this.userAdd.check
      if (!check) {
        this.$message.warning('登录选择信息不存在')
        return
      }
      this.userAdd.loadCheck = true
      this.$ajax({
        url: '/index/ws/wx/bind/checkAdd',
        method: 'post',
        data: this.$qs.stringify({
          checkKey: check.key,
          checkValue: checkItem.value
        })
      }).then(response => {
        if (response.data) {
          switch (response.data['responseCode']) {
            case 'SUCCESS': {
              this.$message.success(response.data['message'])
              this.hideUserAdd()
              this.$nextTick(() => {
                this.loadBindUsers()
              })
              break
            }
            default: {
              this.$message.warning(response.data['message'])
              break
            }
          }
        }
      }, () => {
        this.$message.error('登录请求发送失败')
      }).finally(() => {
        this.userAdd.loadCheck = false
      })
    },
    handleCheckQuit () {
      this.userAdd.showCheck = false
      this.$nextTick(() => {
        this.userAdd.check = null
      })
    },
    handleRedirect (redirectUrl) {
      window.location.replace(this.$contextPath(redirectUrl || '/index/redirect/loginSuccess'))
    }
  },
  watch: {
    showSetting (val) {
      if (!val) {
        this.editMode = false
      }
    }
  }
}
</script>

<style lang="scss">
  @import "../styles/color";
  .layout-bind-users {
    display: inline-block;
  }
  .layout-bind-users-popover {
    width: 240px!important;
    padding: 0!important;
    .users-wrap {
      & > .bind-head {
        display: flex;
        justify-content: space-between;
        align-items: center;
        padding: 12px 12px 0 12px;
        & > .title {
          color: #909399;
          font-size: 12px;
        }
        & > .extra {
          .el-button {
            padding: 0;
          }
        }
      }
      .user-list {
        max-height: 460px;
        & > .user {
          display: flex;
          justify-content: space-between;
          align-items: center;
          padding: 8px 12px;
          & > .label {
            flex: auto;
            overflow: hidden;
            & > .detail {
              margin-top: 4px;
              overflow: hidden;
              white-space: nowrap;
              text-overflow: ellipsis;
              & > .login-id {
                color: #303133;
                font-size: 13px;
                font-weight: bold;
              }
              & > .true-name {
                margin-left: 2px;
                color: #909399;
                font-size: 12px;
              }
            }
          }
          & > .extra {
            flex: none;
            margin-left: 10px;
            .current {
              color: #909399;
              font-size: 12px;
              span {
                margin-left: 2px;
              }
            }
            .is-danger {
              color: $set-danger-color;
            }
          }
          &:hover {
            background-color: rgba(0,0,0,.03);
          }
          & + .user {
            position: relative;
            &:before {
              content: '';
              position: absolute;
              top: 0;
              left: 12px;
              right: 12px;
              height: 0;
              border-top: 1px dashed #ebeef5;
            }
          }
        }
        & > .loading {
          text-align: center;
          i {
            color: #909399;
            font-size: 14px;
          }
        }
        & > .load-err {
          text-align: center;
          .el-button {
            position: relative;
            color: $set-danger-color;
            i {
              font-size: 14px;
            }
          }
        }
      }
      & > .bind-wrap {
        margin-top: 10px;
        padding: 0 12px 12px 12px;
        .el-button {
          width: 100%;
        }
      }
    }
  }
  .layout-bind-user-remove-popover {
    .el-popconfirm {
      .el-popconfirm__main {
        font-size: 12px;
        padding-top: 4px;
        i {
          margin-top: 1px;
          font-size: 14px;
        }
      }
      .el-popconfirm__action {
        .el-button {
          font-size: 12px;
          padding: 5px 10px;
        }
      }
    }
  }
  .layout-bind-user-add-popover {
    .user-add-wrap {
      padding: 20px 15px;
      .el-form {
        .el-form-item {
          &:last-child {
            margin-bottom: 0;
          }
          .el-input {
            .el-input__suffix {
              overflow: hidden;
              .el-input__suffix-inner {
                img {
                  height: 28px;
                  vertical-align: -9px;
                  cursor: pointer;
                }
              }
            }
          }
        }
      }
    }
    .user-add-footer {
      background-color: #fff;
      border-top: 1px solid rgba(0,0,0,.05);
      padding: 15px;
      .el-button {
        width: 100%;
      }
    }
  }
  .layout-bind-user-add-check-popper {
    width: 280px!important;
    max-width: 100%!important;
    .el-popover__title {
      font-size: 12px;
      font-weight: bold;
      text-align: center;
    }
    .check-wrap {
      & > .items {
        list-style: none;
        margin: 0;
        padding: 0;
        & > li {
          .el-button {
            width: 100%;
          }
          & + li {
            margin-top: 10px;
          }
        }
      }
      & > .append {
        margin-top: 15px;
        .el-button {
          width: 100%;
        }
      }
    }
  }
</style>
